import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("Edit Question")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = !_ctx.modal, _ctx.resetForm())),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            class: "btn btn-primary"
          }, "Save")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Question", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass([{'is-invalid':!_ctx.validation.questionText}, "form-control"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.questionText) = $event)),
            required: "",
            cols: "3"
          }, null, 2), [
            [_vModelText, _ctx.questionText]
          ]),
          (!_ctx.validation.questionText)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, "Question text is required"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.selectedType !== undefined && _ctx.selectedType !== _ctx.QuestionType.LONGFILL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("label", null, "Answers:", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex justify-content-start align-items-center mb-2",
                  key: item.id
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                    class: "form-control mx-2"
                  }, null, 8, _hoisted_4), [
                    [_vModelText, item.answer]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeAnswer(parseInt(index))),
                    class: "btn btn-primary float-end"
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "fa fa-minus" }, null, -1)
                  ]), 8, _hoisted_5)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAnswer(parseInt(_ctx.index)))),
                disabled: _ctx.answers.length >= _ctx.maxAnswers,
                class: "btn btn-primary float-end"
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fa fa-plus" }, null, -1)
              ]), 8, _hoisted_6),
              (!_ctx.validation.answers)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    class: _normalizeClass([{'d-block':!_ctx.validation.questionText}, "invalid-feedback"])
                  }, _toDisplayString(_ctx.validation.answersText), 3))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}